export default "__VITE_ASSET__DWIIHed1__"